import { defineStore } from 'pinia';
import { initial_apiKey } from './apiKeys_model.js';
import api from '@/services/api';
import { getParamsUrl } from './apiKeys_utils.js';

export const useApiKeysStore = defineStore('apiKeysStore', {
  state: () => ({
    apiKey: { ...initial_apiKey },
    apiKeys: [],
    page: 1,
    endpoint: '/keys',
  }),
  actions: {
    async findAllApiKeysHTTP(params) {
      const result = await api.get(
        `${this.endpoint}?${getParamsUrl({ limit: this.limit || 25, page: +this.page, ...params })}`,
      );
      if (result && result.data && result.data.length > 0) {
        this.apiKeys.push(...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    async findApiKeyHTTP(codigo) {
      try {
        const result = await api.get(`${this.endpoint}/${codigo}`);
        if (result && result.data) {
          this.apiKey = result.data;
        }
      } catch (error) {
        console.error('Error en findApiKeyHTTP:', error);
      }
    },
    async createApiKeyHTTP() {
      const response = await api.post(`${this.endpoint}`, { Descripcion: this.apiKey.Descripcion });
      if (response.status === 200) {
        this.resetApiKey();
        return true;
      }

      return false;
    },
    async updateApiKeyHTTP(codigo) {
      const response = await api.patch(`${this.endpoint}/${codigo}`, this.apiKey);
      if (response.status === 200) {
        this.resetApiKey();
      }
    },
    async removeApiKeyHTTP(codigo) {
      const response = await api.delete(`${this.endpoint}/${codigo}`);
      if (response.status === 200) {
        this.resetApiKey();
      }
    },
    async firstRequest() {
      this.emptyList();
      this.setPage(1);
      await this.findAllApiKeysHTTP();
    },
    resetApiKey() {
      this.apiKey = { ...initial_apiKey };
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.apiKeys = [];
    },
  },
});
